module.exports = __webpack_public_path__ + "static/img/ic_left.453ca131.svg";